<!-- Bindings/Holdings Header Section -->
<div class="holdings-filter-card bg-white p-3 rounded-3 shadow-sm border mb-4">
  <div class="row align-items-center g-3">

    <!-- Title: Conveying "Book Items" -->
    <div class="col-12">
      <div class="d-flex align-items-center">
        <div
          class="icon-box bg-primary bg-opacity-10 text-primary rounded-3 p-3 me-3 d-flex align-items-center justify-content-center shrink-0">
          <i class="bi bi-journals fs-4"></i>
        </div>
        <div>
          <h5 class="mb-1 fw-bold text-dark text-nowrap">{{ 'Items' | translate }}</h5>
          <p class="mb-0 text-muted small" *ngIf="itemsLocation.length > 1">{{ 'SelectLocationToViewStatus' | translate}} </p>
        </div>
      </div>
    </div>

    <!-- Filter Control -->
    <div class="col-12" *ngIf="itemsLocation.length > 1">
      <div class="d-flex align-items-center justify-content-start gap-2">
        <label class="text-muted small fw-medium text-nowrap">{{ "Location" | translate }}:</label>

        <div class="dropdown grow">
          <button
            class="btn btn-white border w-100 d-flex justify-content-between align-items-center px-3 py-2 rounded-3"
            id="dropdownMenuButtonLocationItem" type="button" data-bs-toggle="dropdown" aria-expanded="false"
            style="background-color: #f8f9fa;">
            <div class="d-flex align-items-center gap-2 overflow-hidden">
              <i class="bi bi-geo-alt-fill text-danger shrink-0"></i>
              <span class="fw-bold text-dark text-truncate">{{ locationName }}</span>
            </div>
            <i class="bi bi-chevron-down small text-muted ms-2 shrink-0"></i>
          </button>

          <ul class="dropdown-menu w-100 shadow-sm border-0 mt-1" aria-labelledby="dropdownMenuButtonLocationItem">
            <li>
              <a class="dropdown-item py-2 d-flex align-items-center" role="button"
                (click)="ChangeLocation('',  'every location')">
                <i class="bi bi-globe text-primary me-2"></i>
                <span class="fw-medium">{{ 'AllLocation' | translate }}</span>
              </a>
            </li>
            <li>
              <hr class="dropdown-divider my-1">
            </li>
            <div style="max-height: 250px; overflow-y: auto;">
              <li *ngFor="let lo of itemsLocation">
                <a class="dropdown-item py-2 d-flex align-items-center" role="button"
                  (click)="ChangeLocation(lo.LOCATIONID, lo.LOCATIONNAMETHAI)">
                  <i class="bi bi-building text-muted me-2"></i>
                  <span>{{ lo.LOCATIONNAMETHAI }}</span>
                </a>
              </li>
            </div>
          </ul>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- Current Checkout Alert -->
<div *ngIf="curentCheckOut.length > 0" class="alert alert-info border-0 shadow-sm mb-4" role="alert">
  <div class="d-flex align-items-start">
    <i class="bi bi-info-circle-fill me-3 mt-1" style="font-size: 1.2rem;"></i>
    <div class="grow">
      <h6 class="alert-heading mb-2">{{'You are borrowing this resource!'|translate}}</h6>
      <p class="mb-2">
        <strong>{{'DueDate'|translate}}:</strong>
        <span class="badge bg-warning text-dark ms-1">{{ curentCheckOut[0].DUEDATE }}</span>
      </p>
      <a href="member/checkout" target="_blank" class="alert-link text-primary">
        <i class="bi bi-list-check me-1"></i>{{'Your are checked outs list' | translate}}
      </a>
    </div>
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
  </div>
</div>

<!-- Items List -->
<div class="mt-4" *ngIf="LoaditemOk == true; else contentLoading">
  <div *ngIf="itemsList.length > 0; else contentNoitem">

    <!-- Item Cards (Book Representation Style) -->
    <!-- Item Cards (Book Representation Style - Compact Single Column) -->
    <div class="item-cards-container row row-cols-1 g-3">
      <div *ngFor="let item of itemsListShow; let i = index" class="col">
        <div class="item-card border-0 shadow-sm rounded-3 h-100">
          <div class="d-flex flex-row align-items-stretch" style="min-height: 140px;">

            <!-- Book Spine (สันหนังสือ) - Compact -->
            <div class="book-spine d-flex flex-column align-items-center py-3 px-1 text-center">
              <div class="spine-line mb-2"></div>
              <div class="color-label-container w-100 mb-2 mx-2"
                *ngIf="(item.COLOR1!='#FFFFFF' && item.COLOR1!='White') || (item.COLOR2!='#FFFFFF' && item.COLOR2!='White') || (item.COLOR3!='#FFFFFF' && item.COLOR3!='White')">
                <span class="color-indicator" [style.background-color]="item.COLOR1" [title]="item.COLOR1"></span>
                <span class="color-indicator" [style.background-color]="item.COLOR2" [title]="item.COLOR2"></span>
                <span class="color-indicator" [style.background-color]="item.COLOR3" [title]="item.COLOR3"></span>
              </div>
              <div class="spine-label shadow-sm mb-3 pt-1 pb-1 px-1 w-100" *ngIf="item.CALLNO">
                <span class="d-block text-break fw-bold font-monospace text-dark"
                  style="font-size: 0.75rem; line-height: 1.2;">
                  {{ item.CALLNO }}
                </span>
              </div>



              <div class="spine-line mt-auto"></div>
            </div>

            <!-- Book Details (Cover Info) - Compact -->
            <div class="book-info grow p-2 pt-2 bg-white d-flex flex-column">

              <!-- Top Row: Barcode & Status -->
              <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-2">
                <div class="d-flex align-items-center gap-2">
                  <span class="badge bg-light text-dark border font-monospace text-nowrap">
                    <span class="text-muted fw-normal me-1" style="font-size: 0.75em;">{{ 'Barcode' | translate
                      }}:</span>{{ item.BARCODE }}
                  </span>
                </div>

                <div [ngSwitch]="item.ITEMSTATUSID">
                  <span *ngSwitchCase="'1'"
                    class="badge bg-success-subtle text-success border border-success-subtle text-nowrap">
                    <i class="bi bi-check-circle-fill me-1"></i>{{ item.ITEMSTATUSNAME }}
                  </span>
                  <span *ngSwitchCase="'31'"
                    class="badge bg-success-subtle text-success border border-success-subtle text-nowrap">
                    <i class="bi bi-check-circle-fill me-1"></i>{{ item.ITEMSTATUSNAME }}
                  </span>
                  <span *ngSwitchCase="'2'"
                    class="badge bg-warning-subtle text-warning-emphasis border border-warning-subtle text-nowrap">
                    <i class="bi bi-clock-history me-1"></i>{{ item.ITEMSTATUSNAME }}
                    <!-- <span class="ms-1" *ngIf="item.DUEDATE">({{ item.DUEDATE }})</span> -->
                  </span>
                  <span *ngSwitchCase="'4'"
                    class="badge bg-danger-subtle text-danger border border-danger-subtle text-nowrap">
                    <i class="bi bi-exclamation-triangle-fill me-1"></i>{{ item.ITEMSTATUSNAME }}
                  </span>
                  <span *ngSwitchDefault
                    class="badge bg-secondary-subtle text-secondary border border-secondary-subtle text-nowrap">
                    <i class="bi bi-info-circle-fill me-1"></i>{{ item.ITEMSTATUSNAME }}
                  </span>
                </div>
              </div>

              <!-- Info Grid (Compact) -->
              <div class="row g-2 mb-2 text-sm pb-2 ">
                <!-- Location & Collection & Details -->
                <div class="col-12 d-flex flex-wrap gap-3 align-items-center">
                  <!-- Location -->
                  <div *ngIf="item.LOCATIONNAMETHAI" class="d-flex align-items-center">
                    <i class="bi bi-geo-alt text-muted me-1 small"></i>
                    <span class="fw-medium small">{{ item.LOCATIONNAMETHAI }}</span>
                  </div>
                  <!-- Collection -->
                  <div *ngIf="item.COLLECTIONNAME" class="d-flex align-items-center">
                    <i class="bi bi-collection text-muted me-1 small"></i>
                    <span class="fw-medium small">{{ item.COLLECTIONNAME }}</span>
                  </div>
                  <!-- Item Type (Class) -->
                  <div *ngIf="item.ITEMCLASSNAME" class="d-flex align-items-center">
                    <i class="bi bi-tag text-muted me-1 small"></i>
                    <span class="fw-medium small">{{ item.ITEMCLASSNAME }}</span>
                  </div>
                  <!-- Unit -->
                  <div *ngIf="replaceSpace(item.UNIT)" class="d-flex align-items-center">
                    <i class="bi bi-journal-album text-muted me-1 small"></i>
                    <span class="fw-medium small">{{ item.UNIT }}</span>
                  </div>
                  <!-- Copy -->
                  <div *ngIf="item.COPY" class="d-flex align-items-center">
                    <span class="badge bg-light text-dark border font-monospace">
                      <span class="text-muted fw-normal me-1" style="font-size: 0.75em;">{{ 'Copy' | translate
                        }}:</span><span class="fw-bold text-dark small">{{ item.COPY }}</span>
                    </span>
                  </div>
                </div>

                <!-- Public Note -->
                <div class="col-12" *ngIf="item.PUBLICNOTE">
                  <div
                    class="alert alert-warning py-1 px-2 mb-0 d-flex align-items-start border-0 bg-warning-subtle text-warning-emphasis top-0">
                    <i class="bi bi-chat-quote-fill me-2 mt-1 small"></i>
                    <span class="small fst-italic">{{ item.PUBLICNOTE }}</span>
                  </div>
                </div>

                <!-- Due Date -->
                <div class="col-12" *ngIf="item.ITEMSTATUSID=='2' && item.DUEDATE">
                  <div
                    class="alert alert-warning d-flex align-items-center py-2 px-3 mt-1 mb-0 border-0 bg-warning-subtle text-warning-emphasis">
                    <i class="bi bi-calendar-event me-2"></i>
                    <strong>{{ 'DueDate' | translate }}:</strong>
                    <span class="ms-2 font-monospace">{{ item.DUEDATE }}</span>
                  </div>
                </div>
              </div>

              <!-- Actions (Bottom Right) -->
              <div class="d-flex justify-content-end gap-2 mt-auto pt-1">
                <!-- Map -->
                <a *ngIf="item.SHOWMAP != 0 && item.SHOWMAP != ''" routerLink="../virtualbookshelf/{{ item.ITEMID }}"
                  target="_blank"
                  class="btn btn-sm btn-light btn-light-walai border rounded-pill text-dark px-3 shadow-none">
                  <i class="bi bi-map me-1"></i>{{ 'Map' | translate }}
                </a>

                <!-- RD Button -->
                <div *ngIf="opacopenRD == true && (item.ITEMSTATUSID=='1' || item.ITEMSTATUSID=='31')">
                  <app-btn-rd [item]="item" [BLOCKUSER]="BLOCKUSER" [mattypeID]="mattypeID"
                    [NDDUserPrivilege]="NDDUserPrivilege"></app-btn-rd>
                </div>

                <!-- Hold -->
                <button *ngIf="item.ITEMSTATUSID=='2' && curentCheckOut.length==0"
                  class="btn btn-sm btn-light btn-light-walai border rounded-pill text-dark px-3 shadow-none"
                  (click)="holdItem(item.BARCODE)">
                  <i class="bi bi-calendar-check me-1"></i>{{ 'Hold' | translate }}
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- View All Button -->
      <div class="text-center mt-3" *ngIf="viewAll == false && itemsList.length > lessItem">
        <button (click)="clickViewAll()" type="button" class="btn btn-light btn-light-walai border rounded-pill py-2">
          <i class="bi bi-chevron-down me-2"></i>{{ 'ViewAllItems' | translate }} ({{ itemsList.length }})
        </button>
      </div>

    </div>

  </div>

</div>
<!-- Loading Template -->
<ng-template #contentLoading>
  <div class="text-center py-5">
    <div class="spinner-border text-primary mb-3" role="status">
      <span class="visually-hidden">{{ 'Loading' | translate }}</span>
    </div>
    <p class="text-muted">{{ 'LoadingItems' | translate }}</p>
  </div>
</ng-template>

<!-- No Items Template -->
<ng-template #contentNoitem>
  <div class="text-center py-5">
    <div class="mb-3">
      <i class="bi bi-inbox" style="font-size: 3rem; color: #cbd5e1;"></i>
    </div>
    <h6 class="text-muted">{{ 'NoItemsInThisLocation' | translate }}</h6>
  </div>
</ng-template>